import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5025/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      Authorization: `Bearer ${token}`
    }
  };
};

export const challengeService = {
  // Send game invitation / challenge
  sendChallenge: async (toUserId, gameSettings) => {
    const response = await axios.post(`${API_URL}/friend-games/invite`, {
      toUserId,
      gameSettings
    }, getAuthHeaders());
    return response.data;
  },

  // Get challenge by ID
  getChallenge: async (invitationId) => {
    const response = await axios.get(`${API_URL}/friend-games/invite/${invitationId}`);
    return response.data;
  },

  // Accept game challenge
  acceptChallenge: async (invitationId) => {
    const response = await axios.post(`${API_URL}/friend-games/invite/${invitationId}/accept`, {}, getAuthHeaders());
    return response.data;
  },

  // Decline game challenge
  declineChallenge: async (invitationId, reason) => {
    const response = await axios.post(`${API_URL}/friend-games/invite/${invitationId}/decline`, { reason }, getAuthHeaders());
    return response.data;
  },

  // Cancel game challenge
  cancelChallenge: async (invitationId) => {
    const response = await axios.post(`${API_URL}/friend-games/invite/${invitationId}/cancel`, {}, getAuthHeaders());
    return response.data;
  },

  // Get received pending challenges
  getReceivedChallenges: async () => {
    const response = await axios.get(`${API_URL}/friend-games/invitations/received`, getAuthHeaders());
    return response.data;
  },

  // Get sent pending challenges
  getSentChallenges: async () => {
    const response = await axios.get(`${API_URL}/friend-games/invitations/sent`, getAuthHeaders());
    return response.data;
  }
};

export default challengeService;
